import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

/**
 * Route-level permission guard.
 *
 * Usage:
 *   <PermissionGuard permission="emp:view">
 *     <EmployeeList />
 *   </PermissionGuard>
 *
 *   <PermissionGuard permissions={["set:dept:edit", "set:rates:edit"]} requireAll={false}>
 *     <SettingsPage />
 *   </PermissionGuard>
 */
const PermissionGuard = ({ permission, permissions, requireAll = false, children }) => {
  const { user, hasPermission, hasAnyPermission, hasAllPermissions } = useAuth();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  let allowed = false;

  if (permission) {
    // Single permission check
    allowed = hasPermission(permission);
  } else if (permissions && permissions.length > 0) {
    // Multiple permissions: AND or OR
    allowed = requireAll
      ? hasAllPermissions(permissions)
      : hasAnyPermission(permissions);
  } else {
    // No permissions specified — allow through
    allowed = true;
  }

  if (!allowed) {
    const slug = user.userData?.companySlug;
    return <Navigate to={`/company/${slug}/dashboard`} replace />;
  }

  return children;
};

export default PermissionGuard;
